<!-- eslint-disable vue/no-mutating-props -->
<script setup lang="ts">
import type { SiteBlock } from '../../../types/site'

const props = defineProps<{ block: SiteBlock }>()

const t = useSiteEditorT()

const COLUMNS = [
  { value: 2, label: t('site.f.cards_grid.opt_2', '2') },
  { value: 3, label: t('site.f.cards_grid.opt_3', '3') },
  { value: 4, label: t('site.f.cards_grid.opt_4', '4') }
] as const

const addCard = () => {
  props.block.data.cards = [
    ...(props.block.data.cards ?? []),
    { title: '', description: '', image: '', link_url: '', link_text: '' }
  ]
}
const removeCard = (i: number) => {
  props.block.data.cards?.splice(i, 1)
}
</script>

<template>
  <!-- eslint-disable vue/no-mutating-props -->
  <UFormField :label="t('site.f.common.heading_optional', 'Heading (optional)')">
    <UInput
      v-model="block.data.headline"
      class="w-full"
    />
  </UFormField>
  <UFormField :label="t('site.f.common.columns_label', 'Columns')">
    <SiteEditorOptionToggle
      :options="COLUMNS"
      :model-value="block.data.columns ?? 3"
      @update:model-value="block.data.columns = Number($event)"
    />
  </UFormField>
  <SiteEditorArrayItemCard
    v-for="(card, i) in block.data.cards ?? []"
    :key="i"
    :label="`${t('site.f.cards_grid.item_label', 'Card')} ${i + 1}`"
    @remove="removeCard(i)"
  >
    <UInput
      v-model="card.title"
      :placeholder="t('site.f.common.title_label', 'Title')"
      class="w-full"
    />
    <UTextarea
      :model-value="card.description ?? ''"
      :rows="2"
      :placeholder="t('site.f.cards_grid.description', 'Description')"
      class="w-full"
      @update:model-value="card.description = String($event)"
    />
    <SiteEditorImagePicker
      :label="t('site.f.common.image_label', 'Image')"
      :model-value="card.image ?? ''"
      @update:model-value="card.image = $event"
    />
    <div class="grid grid-cols-2 gap-2">
      <UInput
        :model-value="card.link_url ?? ''"
        :placeholder="t('site.f.common.link_url_label', 'Link URL')"
        @update:model-value="card.link_url = String($event)"
      />
      <UInput
        :model-value="card.link_text ?? ''"
        :placeholder="t('site.f.common.link_text_label', 'Link text')"
        @update:model-value="card.link_text = String($event)"
      />
    </div>
  </SiteEditorArrayItemCard>
  <UButton
    size="sm"
    variant="outline"
    color="neutral"
    icon="i-lucide-plus"
    @click="addCard"
  >
    {{ t('site.f.cards_grid.add_item', 'Add card') }}
  </UButton>
</template>
